import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState,ListMutations, ListStateItem, ListModuleItem} from '@/store/shared'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';
import ListData from '@/store/shared/list-data';
import CustomsDeclarationElement from './entity'
import Element from './Element'
import Tree from "@/store/shared/entity/tree";

interface CustomsDeclarationElementState extends ListStateItem<CustomsDeclarationElement>{
    editCustomsDeclarationElement:CustomsDeclarationElement,
    element: ListData<Element>;
}

class CustomsDeclarationElementModule extends ListModuleItem<CustomsDeclarationElementState,any,CustomsDeclarationElement>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editCustomsDeclarationElement:new CustomsDeclarationElement(),
        element:new ListData<Element>(),
    }
    actions={
        async getAll(context:ActionContext<CustomsDeclarationElementState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('services/app/CustomsDeclarationElement/GetCustomsDeclarationElement',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<CustomsDeclarationElement>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
        async create(context:ActionContext<CustomsDeclarationElementState,any>,payload:any){
            await $http.post('services/app/CustomsDeclarationElement/Create',payload.data);
        },
        async update(context:ActionContext<CustomsDeclarationElementState,any>,payload:any){
            await $http.put('services/app/CustomsDeclarationElement/Update',payload.data);
        },
        async delete(context:ActionContext<CustomsDeclarationElementState,any>,payload:any){
            await $http.delete('services/app/CustomsDeclarationElement/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<CustomsDeclarationElementState,any>,payload:any){
            let reponse=await $http.get('services/app/CustomsDeclarationElement/Get?Id='+payload.id);
            return reponse.data.result as CustomsDeclarationElement;
        },
        async getElement(context: ActionContext<CustomsDeclarationElementState, any>, payload: any) {
            context.state.element.loading = true;
            let reponse = await $http.get('services/app/CustomsDeclarationElement/GetElement', {params: payload.data});
            context.state.element.loading = false;
            let page = reponse.data.result;
            context.state.element.totalCount = page.totalCount;
            context.state.element.list = page.items;
            
        },
    };
    overrideMutations={
        edit(state:CustomsDeclarationElementState,customsdeclarationelement:CustomsDeclarationElement){
            state.editCustomsDeclarationElement.id=customsdeclarationelement.id;
            state.editCustomsDeclarationElement.commodityCode=customsdeclarationelement.commodityCode;
            state.editCustomsDeclarationElement.commodityDescription=customsdeclarationelement.commodityDescription;
            state.editCustomsDeclarationElement.elementList = new Array<Element>();
            customsdeclarationelement.elementList.forEach(item => {
                state.editCustomsDeclarationElement.elementList.push(item);
            })
        }
    }
}
const customsDeclarationElementModule=new CustomsDeclarationElementModule();
export default customsDeclarationElementModule;